import {
  SlTab
} from "./chunk.44IVVTR5.js";

// src/components/tab/tab.ts
var tab_default = SlTab;
SlTab.define("sl-tab");

export {
  tab_default
};
